import { useEffect } from 'react';
import Cal, { getCalApi } from '@calcom/embed-react';

/**
 * Cal.com inline embed for Hallie's Discovery Call booking.
 * Themed to the warm-black + soft-gold brand palette.
 */
const CAL_LINK = 'hallie-vingno-sy5udo/discovery-call';
const CAL_NAMESPACE = 'discovery-call';

export default function CalEmbed() {
  useEffect(() => {
    (async () => {
      const cal = await getCalApi({ namespace: CAL_NAMESPACE });
      cal('ui', {
        cssVarsPerTheme: {
          light: {
            'cal-brand': '#1C1C1C',
            'cal-brand-emphasis': '#C9A24D',
            'cal-bg': '#F4EFEA',
            'cal-bg-emphasis': '#FBF7F2',
            'cal-text': '#1C1C1C',
            'cal-text-emphasis': '#1C1C1C',
            'cal-border': '#E6CFC7',
            'cal-border-emphasis': '#C9A24D',
          },
        },
        hideEventTypeDetails: false,
        layout: 'month_view',
      });
    })();
  }, []);

  return (
    <div data-testid="cal-embed" className="bg-[#F4EFEA] border border-[#E6CFC7]">
      <Cal
        namespace={CAL_NAMESPACE}
        calLink={CAL_LINK}
        style={{ width: '100%', height: '720px', overflow: 'auto' }}
        config={{ layout: 'month_view' }}
      />
    </div>
  );
}
